import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import ModalContainer from "../../../../components/modals/ModalContainer";
import { RiArrowDropDownLine } from "react-icons/ri";
import { BeatLoader } from "react-spinners";
import { BiArrowBack } from "react-icons/bi";
import PageTitle from "../../../../components/partials/PageTitle";
import PaySavingsPremium from "../../../../components/modals/policy/PaySavingsPremium";
import ReviewInformation from "./../../../../components/customer/policy application/ReviewInformation";
import DetailsInformation from "../../../../components/customer/policy application/savingsPolicy/DetailsInformation";
import Transactions from "../../../../components/customer/policy application/savingsPolicy/Transactions";
import {
  getSingleAppliedSavingsPolicy,
  resetOtherCovers,
} from "../../../../redux/slice/policy/savingsPolicy/savingsPolicySlice";
import SavingsRiskInformation from "../../../../components/customer/policy application/savingsPolicy/SavingsRiskInformation";
import {
  getPolicySavingsDocument,
  resetUnderwriting,
  resetUnderwritingStatus,
} from "../../../../redux/slice/underwriting/underwritingSlice";
import PreviewSavingsPolicyAppSchedule from "./PreviewSavingsPolicyAppSchedule";
import PaymentSchedule from "./../../../../components/policy/PaymentSchedule";
import SavingsPaymentSchedule from "../../../../components/policy/SavingsPaymentSchedule";

const CustomerSavingsPolicyView = () => {
  const { customer_policy_details, isLoading, isPolicyEdited, isSuccess } =
    useSelector((state) => state.savingsPolicy);
  const { user_permissions } = useSelector((state) => state?.auth?.user);
  const [underwrite, setUnderwrite] = useState();
  const [premiumPayment, setPremiumPayment] = useState();
  const [dropdownShow, setDropdownShow] = useState(false);
  const [hasInitiateClaim, setHasInitiateClaim] = useState(null);
  const [editPloicy, setEditPolicy] = useState(false);
  // const hidePaymentBtn =
  //   customer_policy_details?.customer_transactions?.data?.some(
  //     (obj) => obj.complete_payment === "1"
  //   );

  const { state } = useLocation();
  const navigate = useNavigate();
  const dropdownRef = useRef(null);
  const confirmRenewal = useRef(null);
  const confirmRenewalPromptRef = useRef(null);

  const breadcrumb = {
    from: {
      title: "Applied policies",
      link: "/admin/all-applied-savings-policies",
    },
    current: {
      title: "customer policy view",
      link: null,
    },
  };

  //   local state declarations
  const [tab, setTab] = useState("details");

  const dispatch = useDispatch();

  const handleRenewal = () => {
    if (customer_policy_details?.reminder[0] === false) {
      confirmRenewalPromptRef?.current?.click();
      navigate("/admin/policy-application/renewal", {
        state,
      });
    } else {
      confirmRenewal?.current.click();
    }
  };

  // Function to calculate the total amount
  function calculateTotalAmount(paymentArray) {
    let totalAmount = 0;

    // Iterate through the array and sum up the amounts
    paymentArray.forEach((payment) => {
      if (payment.amount_paid) {
        totalAmount += parseFloat(payment.amount_paid);
      }
    });

    return totalAmount;
  }

  const temp_policy_attach_data = {
    effective_date: customer_policy_details?.policy_app_details?.effectiveDate,
    end_date: customer_policy_details?.policy_app_details?.endDate,
    repayment_frequency:
      customer_policy_details?.policy_app_details?.repayment_frequency,
    sum_assured: parseInt(
      customer_policy_details?.policy_app_details?.sumAssured
    ),
    total_premium: parseInt(
      customer_policy_details?.policy_app_details?.total_premium
    ),
    policy_id: state?.policy_id,
    customer_id: customer_policy_details?.policy_app_details?.customerId,
  };

  useEffect(() => {
    if (state?.customerId) {
      dispatch(
        getSingleAppliedSavingsPolicy({
          customer_id: state?.customerId,
          policy_number: state?.policyAppNumber,
        })
      );
      dispatch(
        getPolicySavingsDocument({
          customer_id: state?.customerId,
          policy_application_number: state?.policyAppNumber,
        })
      );
    }
    dispatch(resetUnderwritingStatus());
    dispatch(resetUnderwriting());
  }, []);

  useEffect(() => {
    if (isSuccess) {
      //   dispatch(resetPolicyStatus());
    }
  }, [isSuccess]);

  useEffect(() => {
    dispatch(resetOtherCovers());
  }, [dispatch]);

  useEffect(() => {
    setUnderwrite(
      user_permissions?.some((permission) => permission.name === "underwrite")
    );

    setPremiumPayment(
      user_permissions?.some(
        (permission) => permission.name === "premium payment"
      )
    );

    setHasInitiateClaim(
      user_permissions?.some(
        (permission) => permission.name === "initiate claim"
      )
    );
    setEditPolicy(
      user_permissions?.some(
        (permission) => permission.name === "edit applied policy"
      )
    );
  }, [user_permissions]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      const dropdown = document.querySelector(".more_actions_drowdown");
      if (
        dropdown &&
        !dropdown.contains(event.target) &&
        !dropdownRef.current.contains(event.target)
      )
        setDropdownShow(false);
    };

    document.addEventListener("click", handleClickOutside);

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  if (
    !customer_policy_details ||
    !customer_policy_details?.policy_app_details
  ) {
    return (
      <div className="mt-2">
        <BeatLoader
          height="80"
          width="80"
          radius="9"
          color="#2e3192"
          ariaLabel="three-dots-loading"
          wrapperStyle={{}}
          wrapperClassName=""
          visible={true}
        />
      </div>
    );
  }

  return (
    <>
      {/* page title */}
      <PageTitle title="Customer Savings Policy View" breadcrumb={breadcrumb} />
      {/* end page title */}

      <div className="row">
        <div className="col-md-12">
          <div className="card ">
            <div className="card-body">
              <div className="d-flex justify-content-end mb-2">
                <Link
                  className="btn btn-sm btn-primary d-flex align-items-center"
                  to="/admin/all-applied-savings-policies"
                >
                  <BiArrowBack />
                  <span>Back</span>
                </Link>
              </div>
              <div className="border border-1 rounded-1 p-2">
                <div className="row">
                  <div className="col-md-11">
                    {/* <div className="row">
                      <div className="col-md-4">
                        <div className="d-flex align-items-center gap-2">
                          <h5>Customer Name: </h5>
                          <Link
                            to={`/admin/customer-profile/${customer_policy_details?.policy_app_details?.customer_uuid}`}
                          >
                            {customer_policy_details?.policy_app_details
                              ?.customerFirstName +
                              " " +
                              customer_policy_details?.policy_app_details
                                ?.customerLastName}
                          </Link>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="d-flex align-items-center gap-2">
                          <h5>Marketer/Agent:</h5>
                          <span>
                            {customer_policy_details?.policy_app_details
                              ?.agentFirstName +
                              " " +
                              customer_policy_details?.policy_app_details
                                ?.agentLastName}
                          </span>
                        </div>
                      </div>
                      <div className="col-md-2">
                        <div className="d-flex align-items-center">
                          <button className="btn btn-sm btn-primary">
                            Edit
                          </button>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="d-flex align-items-center gap-2">
                          <h5>Customer ID:</h5>
                          <span>
                            {
                              customer_policy_details?.policy_app_details
                                ?.customerId
                            }
                          </span>
                        </div>
                      </div>
                    </div> */}
                    <div className="d-flex align-items-center justify-content-between flex-wrap">
                      {/* Customer Name */}
                      <div className="d-flex align-items-center gap-2">
                        <h5>Customer Name:</h5>
                        <Link
                          to={`/admin/customer-profile/${customer_policy_details?.policy_app_details?.customer_uuid}`}
                        >
                          {customer_policy_details?.policy_app_details
                            ?.customerFirstName +
                            " " +
                            customer_policy_details?.policy_app_details
                              ?.customerLastName}
                        </Link>
                      </div>

                      {/* Marketer/Agent */}
                      <div className="d-flex align-items-center gap-2">
                        <h5>Marketer/Agent:</h5>
                        <span>
                          {customer_policy_details?.policy_app_details
                            ?.agentFirstName +
                            " " +
                            customer_policy_details?.policy_app_details
                              ?.agentLastName}
                        </span>
                      </div>

                      {/* Edit Button */}
                      {editPloicy && (
                        <div>
                          <Link
                            className="btn btn-sm text-white d-flex align-items-center justify-content-center"
                            style={{
                              backgroundColor: "#0E9CFF",
                              width: "70px",
                            }}
                            to={`/admin/customer-savings-policy-view/edit`}
                            state={{
                              customerId:
                                customer_policy_details?.policy_app_details
                                  ?.customerId,
                              policyAppNumber:
                                customer_policy_details?.policy_app_details
                                  ?.policyAppNumber,
                              policy_id:
                                customer_policy_details?.policy_app_details
                                  ?.policy_id,
                            }}
                          >
                            Edit
                          </Link>
                        </div>
                      )}
                    </div>

                    {/* Second row */}
                    <div className="mt-3 d-flex align-items-center gap-2">
                      <h5>Customer ID:</h5>
                      <span>
                        {
                          customer_policy_details?.policy_app_details
                            ?.customerId
                        }
                      </span>
                    </div>
                  </div>
                </div>
                <div className="d-flex my-1">
                  {/* {parseFloat(customer_policy_details?.policy_app_details?.totalPremium) ===
    // parseFloat(customer_policy_details?.payment_amount)} */}
                  {customer_policy_details?.policy_app_details?.status ===
                  "1" ? (
                    <div>
                      {underwrite && (
                        <Link
                          to={"/admin/customer-savings-policy-view/underwrite"}
                          // className='btn btn-sm btn-primary me-2 mt-1 text-white col-md-2 col-sm-3'
                        >
                          <span className="btn btn-sm btn-primary me-2 mt-1 text-white col-md- col-sm-">
                            Under-write
                          </span>
                        </Link>
                      )}
                    </div>
                  ) : (
                    <div className="d-flex me-2">
                      {/* { premiumPayment && parseFloat(customer_policy_details?.policy_app_details?.sumAssured) !==
                        parseFloat(calculateTotalAmount(customer_policy_details?.payment_details)) && 
                        customer_policy_details?.policy_app_details?.status !== '4'  && customer_policy_details?.policy_app_details?.status !== '5' && ( */}
                      {premiumPayment &&
                        customer_policy_details?.policy_app_details?.status !==
                          "4" &&
                        customer_policy_details?.policy_app_details?.status !==
                          "5" && (
                          <div
                            className="btn btn-sm btn-primary me-2 mt-1 "
                            data-bs-toggle="modal"
                            data-bs-target="#pay_premium"
                          >
                            Pay Premium
                          </div>
                        )}
                      {customer_policy_details?.policy_app_details?.status ===
                        "3" && (
                        <Link
                          to={"/admin/savings-claims"}
                          state={
                            customer_policy_details?.policy_app_details
                              ?.policyAppNumber
                          }
                        >
                          <div className="btn btn-sm btn-primary me-2 mt-1 ">
                            Process Claim
                          </div>
                        </Link>
                      )}
                      <div className="position-relative">
                        <div
                          className="btn btn-sm btn-primary me- mt-1"
                          onClick={() => setDropdownShow(!dropdownShow)}
                          ref={dropdownRef}
                        >
                          <span>More Actions</span>
                          <span>
                            <RiArrowDropDownLine size={20} />
                          </span>
                        </div>
                        <div
                          className={`position-absolute shadow-lg rounded-2 p- more_actions_drowdown ${
                            dropdownShow ? "show" : ""
                          }`}
                        >
                          <ul className="w-100">
                            <li
                              onClick={() => {
                                setDropdownShow(!dropdownShow);
                                navigate(
                                  "/admin/customer-savings-policy-view/policy-schedule"
                                );
                              }}
                            >
                              View Policy Document
                            </li>
                            {customer_policy_details?.policy_app_details
                              ?.proposal_document ? (
                              <li
                                onClick={() => setDropdownShow(!dropdownShow)}
                              >
                                <a
                                  href={
                                    customer_policy_details?.policy_app_details
                                      ?.proposal_document
                                  }
                                  target="_blank"
                                  className="text-grey"
                                >
                                  View Proposal Document
                                </a>
                              </li>
                            ) : null}
                            <li
                              onClick={() => {
                                setDropdownShow(!dropdownShow);
                              }}
                              data-bs-toggle="modal"
                              data-bs-target="#policy_schedule"
                            >
                              View Payment Schedule
                            </li>
                            {hasInitiateClaim &&
                              customer_policy_details?.policy_app_details
                                ?.status !== "4" &&
                              customer_policy_details?.policy_app_details
                                ?.status !== "5" && (
                                <li
                                  onClick={() => setDropdownShow(!dropdownShow)}
                                >
                                  <Link
                                    to={"/admin/savings-claims"}
                                    state={
                                      customer_policy_details
                                        ?.policy_app_details?.policyAppNumber
                                    }
                                  >
                                    Initiate Claim
                                  </Link>
                                </li>
                              )}
                            <li onClick={() => setDropdownShow(!dropdownShow)}>
                              Debit Note
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  )}

                  {customer_policy_details?.policy_app_details?.status ===
                    "3" && (
                    <div
                      className="btn btn-sm btn-primary me-2 mt-1"
                      ref={confirmRenewalPromptRef}
                      data-bs-toggle="modal"
                      data-bs-target="#confirm_renewal"
                    >
                      <span>Renew Policy</span>
                    </div>
                  )}
                </div>
                {/* {customer_policy_details ? ( */}
                <div className="row my-3">
                  <div>
                    <ul className="nav nav-pills bg-nav-pills nav-justified mb-3">
                      <li className="nav-item cursor-p">
                        <span
                          onClick={() => setTab("details")}
                          aria-expanded="false"
                          className={`nav-link rounded-0 p-tab-y-1 ${
                            tab === "details" && "active"
                          } border`}
                        >
                          <i className="mdi mdi-home-variant d-md-none d-block"></i>
                          <span className="d-none d-md-block">Details</span>
                        </span>
                      </li>
                      <li className="nav-item cursor-p">
                        <span
                          // data-bs-toggle='tab'
                          onClick={() => setTab("risk_covered")}
                          aria-expanded="true"
                          className={`nav-link rounded-0 ${
                            tab === "risk_covered" && "active"
                          } border`}
                        >
                          <i className="mdi mdi-account-circle d-md-none d-block"></i>
                          <span className="d-none d-md-block">
                            Risk Covered
                          </span>
                        </span>
                      </li>
                      <li className="nav-item cursor-p">
                        <span
                          // data-bs-toggle='tab'
                          onClick={() => setTab("schedule")}
                          aria-expanded="true"
                          className={`nav-link rounded-0 ${
                            tab === "schedule" && "active"
                          } border`}
                        >
                          <i className="mdi mdi-account-circle d-md-none d-block"></i>
                          <span className="d-none d-md-block">
                            Payment Schedule
                          </span>
                        </span>
                      </li>
                      <li className="nav-item cursor-p">
                        <span
                          // data-bs-toggle='tab'
                          onClick={() => setTab("transaction")}
                          aria-expanded="true"
                          className={`nav-link rounded-0 ${
                            tab === "transaction" && "active"
                          } border`}
                        >
                          <i className="mdi mdi-account-circle d-md-none d-block"></i>
                          <span className="d-none d-md-block">
                            Transactions
                          </span>
                        </span>
                      </li>
                    </ul>
                    {tab === "details" && (
                      <div className="details active" id="details">
                        <DetailsInformation
                          details={customer_policy_details?.policy_app_details}
                          current_balance={
                            customer_policy_details?.current_balance
                          }
                          payment_amount={
                            customer_policy_details?.current_balance
                          }
                          total_deposit={customer_policy_details?.total_deposit}
                          last_deposit={customer_policy_details?.last_deposit}
                          last_payment_date={
                            customer_policy_details?.last_payment_date
                          }
                          total_claim={customer_policy_details?.total_claim}
                          last_claim_date={
                            customer_policy_details?.last_claim_date
                          }
                        />
                      </div>
                    )}
                    {tab === "risk_covered" && (
                      <div className="active" id="risk_covered">
                        <SavingsRiskInformation
                          details={customer_policy_details?.policy_app_rsk}
                          life_cover={customer_policy_details?.life_cover}
                          death_claim={customer_policy_details?.death_claim}
                        />
                      </div>
                    )}
                    {tab === "schedule" && (
                      <div className="active" id="schedule">
                        <SavingsPaymentSchedule />
                      </div>
                    )}
                    {tab === "transaction" && (
                      <div className="active" id="transaction">
                        <Transactions
                          customerTransactions={
                            customer_policy_details?.customer_transaction
                          }
                          view
                          total_claim={customer_policy_details?.total_claim}
                          status={
                            customer_policy_details?.policy_app_details?.status
                          }
                        />
                      </div>
                    )}
                  </div>
                </div>
                {/* ) : ( "Something went wrong!" )} */}
              </div>
            </div>
          </div>
        </div>
      </div>
      <ModalContainer
        modal_id="pay_premium"
        modal_width="modal-md"
        bradius="rounded-2"
      >
        <PaySavingsPremium
          customer_id={customer_policy_details?.policy_app_details?.customerId}
          policy_app_no={
            customer_policy_details?.policy_app_details?.policyAppNumber
          }
          policy_id={customer_policy_details?.policy_app_rsk?.[0]?.policy_id}
          life_cover_id={customer_policy_details?.life_cover?.life_cover_id}
        />
      </ModalContainer>
      <PreviewSavingsPolicyAppSchedule
        modal_id="policy_schedule"
        // policyID={policyID}
        edit
        data={temp_policy_attach_data}
        policyDetails={customer_policy_details?.policy_app_details}
      />
    </>
  );
};

export default CustomerSavingsPolicyView;
